import React, { useState, useCallback } from "react"
import { View, Text, TouchableOpacity, Linking } from "react-native"
import Config from "../constants/Config"
import { Entypo, FontAwesome } from "@expo/vector-icons"
import Colors from "../constants/Colors"
import { useSelector } from "react-redux"
import axios from "axios"

const FolderItem = ({ folder }) => {
  const [expanded, setExpanded] = useState(false)
  const toggle = useCallback(() => setExpanded((e) => !e), [])

  const token = useSelector((store) => store.user.token)

  const handleView = (file) => {
    const url = `${Config.aioUrl}/project/file/get?file_id=${file.id}`

    const reqHedear = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    }

    axios({
      method: "get",
      url: url,
      headers: reqHedear,
      responseType: "blob",
    })
      .then(function (response) {
        if (response?.data?.code == 401) {
          alert("نیاز است مجددا به سیستم ورود کنید.")
          logOut()
        }

        try {
          const blobUrl = window.URL.createObjectURL(new Blob([response.data]))

          const name = file.bucket?.split("/").pop()

          if (blobUrl) {
            const link = document.createElement("a")
            link.href = blobUrl
            link.setAttribute("download", name)
            document.body.appendChild(link)
            link.click()
          } else alert("عکس مورد نظر یافت نشد.")
        } catch (error) {
          console.log(error)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  return (
    <View style={{ marginBottom: 15, gap: 10 }}>
      <TouchableOpacity
        onPress={toggle}
        style={{
          flexDirection: "row-reverse",
          justifyContent: "space-between",
          alignItems: "center",
          paddingVertical: 12,
          paddingHorizontal: 12,
          backgroundColor: Colors.cardBg,
          borderRadius: 6,
          gap: 2,
        }}
      >
        <Text style={{ fontSize: 14, fontWeight: "900", fontFamily: "IranSans-Medium" }}>
          {folder.title}
        </Text>

        {expanded ? (
          <Entypo name="minus" size={24} color="black" />
        ) : (
          <Entypo name="plus" size={24} color="black" />
        )}
      </TouchableOpacity>

      {expanded &&
        folder.files?.map((file) => (
          <View
            key={file.id}
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingVertical: 6,
              paddingHorizontal: 20,
            }}
          >
            <Text style={{ fontSize: 16, marginRight: 6, fontFamily: "IranSans-Medium" }}>📄</Text>
            <Text style={{ flex: 1, fontSize: 14, fontFamily: "IranSans-Medium" }}>
              {file.bucket.split("/").pop()}
            </Text>
            <TouchableOpacity
              onPress={() => handleView(file)}
              style={{
                paddingVertical: 4,
                paddingHorizontal: 10,
                borderWidth: 1,
                borderColor: "#3498db",
                borderRadius: 4,
              }}
            >
              <Text style={{ fontSize: 13, color: "#3498db", fontFamily: "IranSans-Medium" }}>
                دانلود
              </Text>
            </TouchableOpacity>
          </View>
        ))}
    </View>
  )
}

const FolderStructureTree = ({ folders = [] }) => {
  return (
    <View style={{ paddingVertical: 10 }}>
      {folders.map((folder) => (
        <FolderItem key={folder.id} folder={folder} />
      ))}
    </View>
  )
}

export default FolderStructureTree
